// var bilet = {
//     idRunda: this.props.rundaVal.id,
//     roundUnique: roundUnique,
//     numereArr: [val],
//     timeStart: this.props.rundaVal.timeStart,
//     numeLot: this.props.rundaVal.selectedLot,
//     gameType: '',
//     odds: [],
//     value: '0',
//     currency: '',
//     checked: [],
//     cotaTot: 0,
//     castigEv: 0,
//     sum: [],
// coteFixe: [],
//     valid: false,
//     pariat: false,
//     mesaj: ''
// }

export default function (state = null, action) {
    var prevState = state;
    switch (action.type) {
        case 'BILET_NOU': {
            if (state === null) {
                state = [action.payload];
            } else {
                state = state.concat(action.payload)
            }
            return state;
        }
        case 'BILET_NUMERE': {
            // console.log('BILET_NUMERE', action.payload);
            state = state.map((val, i) => {
                if (val.position === action.payload.position) {
                    if (action.payload.numere.length > action.payload.odds.length) {
                        var chk = action.payload.odds.length;
                    } else {
                        chk = action.payload.numere.length;
                    }
                    val = {
                        ...state[i],
                        numereArr: action.payload.numere,
                        checked: [chk],
                        mesaj: '',
                        pariat: false,
                        valid: true,
                    }
                    return val;
                } else {
                    return val;
                }
            });
            return state;
        }
        case 'BILET_NOU_SAMEPOZ': {
            state = state.map((val, i) => {
                if (val.position === action.payload.position) {
                    val = action.payload;
                    return val;
                } else {
                    return val;
                }
            });
            return state;
        }
        case 'CHANGE_ROUND': {
            state = state.map((val, i) => {
                if (val.position === action.payload.position) {
                    val = {
                        ...state[i],
                        ...action.payload,
                        futureArr: action.payload.futureArr
                    };
                    return val;
                } else {
                    return val;
                }
            });
            return state;
        }
        case 'BILET_SAVE_FAV': {
            // console.log('BILET_SAVE_FAV', action.payload);
            state = state.map((val, i) => {
                if (val.position && val.position === action.payload.position) {
                    val = {
                        ...state[i],
                        nrFavorite: action.payload.nrFavorite,
                    }
                    return val;
                } else {
                    return val;
                }
            });
            return state;
        }
        case 'BILET_SAVE_FAV_FROM_AXIOS': {
            if (action.payload.value !== null) {
                state = state.map((val, i) => {
                    if (val.position && val.position === action.payload.extra) {
                        val = {
                            ...state[i],
                            nrFavorite: action.payload.response.value,
                        }
                        return val;
                    } else {
                        return val;
                    }
                });
                return state;
            }
            return state;
        }
        case 'BILET_MIZA': {
            // console.log('BILET_NUMERE', action.payload);
            state = state.map((val, i) => {
                if (val.position === action.payload.position) {
                    val = {
                        ...state[i],
                        miza: action.payload.miza,
                        mesaj: '',
                        pariat: false,
                        valid: true,
                    }
                    return val;
                } else {
                    return val;
                }
            });
            return state;
        }
        case 'BILET_CHECKED': {
            // console.log('BILET_CHECKED', action.payload);
            state = state.map((val, i) => {
                if (val.position === action.payload.position) {
                    val = {
                        ...state[i],
                        checked: action.payload.checked,
                        mesaj: '',
                        pariat: false,
                        valid: true,
                    }
                    return val;
                } else {
                    return val;
                }
            });
            return state;
        }
        case 'BILET_CALCUL': {
            // console.log('BILET_CALCUL', action.payload);
            state = state.map((val, i) => {
                if (val.position === action.payload.position) {
                    val = {
                        ...state[i],
                        cotaTot: action.payload.cotaTot,
                        castigEv: action.payload.castigEventual,
                        sum: action.payload.sum,
                        sumDefault: action.payload.sumDefault,
                        coteFixe: action.payload.coteFixe
                    }
                    return val;
                } else {
                    return val;
                }
            });
            return state;
        }
        case 'SEND_TICKET': {
            state = state.map((val, i) => {
                if (val.position === action.payload.position) {

                    if (val.future === 0) {
                        var mesaj = action.payload.mesaj
                        var valid = action.payload.valid
                    } else {
                        var nrSuccess = val.futureSuccess
                        var nrError = val.futureError
                        var roundsError = val.futureErrorRounds
                        if (action.payload.status === 'succes') {
                            nrSuccess = val.futureSuccess + 1
                        } else {
                            nrError = val.futureError + 1;
                            roundsError.push(action.payload.end_time.split(' ')[1]);
                        }
                        var mesajSuccess = '';
                        var mesajError = '';
                        if (nrSuccess > 0) { mesajSuccess = nrSuccess + ' ' + val.futureMessage[0] }
                        if (nrError > 0) {
                            mesajError = nrError + ' ' + val.futureMessage[1] + ' ' + roundsError.join(', ')
                            valid = false
                        } else {
                            valid = true
                        }
                        mesaj = mesajSuccess + '\n' + mesajError
                    }
                    val = {
                        ...state[i],
                        pariat: true,
                        mesaj: mesaj,
                        valid: valid,
                        futureSuccess: nrSuccess,
                        futureError: nrError,
                        futureErrorRounds: roundsError
                    }
                    return val;
                } else {
                    return val;
                }
            });
            return state;
        }
        case 'RESET_MESSAGE': {
            state = state.map((val, i) => {

                val = {
                    ...state[i],
                    mesaj: '',
                    futureSuccess: 0,
                    futureError: 0,
                    futureErrorRounds: [],
                }
                return val;

            });
            return state;
        }
        case 'VALID_TICKET': {
            state = state.map((val, i) => {
                if (val.position === action.payload.position) {
                    val = {
                        ...state[i],
                        mesaj: action.payload.mesaj,
                        valid: action.payload.valid
                    }
                    return val;
                } else {
                    return val;
                }
            });
            return state;
        }
        case 'BILET_DELETE': {
            state.forEach(function (val, i) {
                if (val.position === action.payload.position) {
                    state = state.slice(0, i).concat(state.slice(i + 1));
                }
            })
            return state;
        }
        case 'BILET_FUTURE': {
            state = state.map((val, i) => {
                if (val.position === action.payload.position) {
                    val = {
                        ...state[i],
                        future: parseInt(action.payload.future, 10),
                        futureArr: action.payload.futureArr,
                    }
                    return val;
                } else {
                    return val;
                }
            });
            return state;
        }
        default: {
            state = prevState;
        }
    }
    return state;

}